import Cookies from 'universal-cookie';
import PageDataLoader from '../../lib/page-data/loader';
import PageKey from '../../lib/page-data/key';
import {
  SHOP_ASSIGNMENTS_REQUEST,
  SHOP_ASSIGNMENTS_RECEIVE,
  SHOP_ASSIGNMENTS_FAILURE,
  SHOP_CATEGORY_PAGE_REQUEST,
  SHOP_CATEGORY_PAGE_RECEIVE,
  SHOP_CATEGORY_PAGE_FAILURE,
  SHOP_LANDING_PAGE_REQUEST,
  SHOP_LANDING_PAGE_RECEIVE,
  SHOP_LANDING_PAGE_FAILURE,
  SHOP_PRODUCT_PAGE_REQUEST,
  SHOP_PRODUCT_PAGE_RECEIVE,
  SHOP_PRODUCT_PAGE_FAILURE,
  PAGE_DATA_LOAD,
  UNAUTHORISED_RESPONSE,
  SHOP_BANNER_CLOSED_TOGGLED,
} from '../action-types';
import ApiRequestException from '../../exceptions/api-request-exception';

export const fetchLandingPagePageData = (clubId, request) => async (dispatch) => {
  try {
    dispatch({ type: SHOP_LANDING_PAGE_REQUEST });
    const pageKey = new PageKey(clubId, 'shop');
    const pageData = await PageDataLoader.getPageData(pageKey, request);
    dispatch({ type: SHOP_LANDING_PAGE_RECEIVE, payload: { ...pageData.data } });
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
    return {};
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }

    dispatch({ type: SHOP_LANDING_PAGE_FAILURE, payload: { clubId, statusCode, error } });
    return { error };
  }
};

export const fetchCategoryPagePageData = (clubId, category, page, request) => async (dispatch) => {
  try {
    dispatch({ type: SHOP_CATEGORY_PAGE_REQUEST, payload: { category, page } });
    const pageKey = new PageKey(clubId, 'shop_category', { category, page });
    const pageData = await PageDataLoader.getPageData(pageKey, request);
    dispatch({ type: SHOP_CATEGORY_PAGE_RECEIVE, payload: { category, page, ...pageData.data } });
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
    return {};
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }

    dispatch({
      type: SHOP_CATEGORY_PAGE_FAILURE,
      payload: { clubId, category, page, statusCode, error },
    });
    return { error };
  }
};

export const fetchProductPageData = (clubId, productId, request) => async (dispatch) => {
  try {
    dispatch({ type: SHOP_PRODUCT_PAGE_REQUEST, payload: { productId } });
    const pageKey = new PageKey(clubId, 'product', { id: productId });
    const pageData = await PageDataLoader.getPageData(pageKey, request);
    dispatch({ type: SHOP_PRODUCT_PAGE_RECEIVE, payload: { productId, ...pageData.data } });
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
    return {};
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }

    dispatch({
      type: SHOP_PRODUCT_PAGE_FAILURE,
      payload: { clubId, productId, statusCode, error },
    });
    return { error };
  }
};

export const toggleShopBannerClosed = (closed) => (dispatch) => {
  const cookies = new Cookies();

  if (closed) {
    cookies.set('SHOP_BANNER_CLOSED', true, { maxAge: 31536000000 });
  } else {
    cookies.remove('SHOP_BANNER_CLOSED');
  }

  dispatch({
    type: SHOP_BANNER_CLOSED_TOGGLED,
    payload: closed,
  });
};

export const fetchShopAssignments = (clubId) => async (dispatch) => {
  try {
    dispatch({ type: SHOP_ASSIGNMENTS_REQUEST, payload: { clubId } });

    const { makeIsomorphicApiRequest } = await import('../../lib/api-proxy');

    const response = await makeIsomorphicApiRequest(`/v2/club-website/${clubId}/shop-assignments`, {
      method: 'GET',
    });

    if (response.status !== 200) {
      if (response.status === 401 || response.status === 403) {
        dispatch({ type: UNAUTHORISED_RESPONSE });
      }
      dispatch({
        type: SHOP_ASSIGNMENTS_FAILURE,
        payload: {
          clubId,
          error: new ApiRequestException('Error retrieving assignments', response.status),
        },
      });
    } else {
      const data = await response.json();
      dispatch({ type: SHOP_ASSIGNMENTS_RECEIVE, payload: { clubId, data } });
      if (data.length) {
        toggleShopBannerClosed(false)(dispatch);
      }
    }
  } catch (error) {
    dispatch({ type: SHOP_ASSIGNMENTS_FAILURE, payload: { clubId, error } });
  }
};
